/**
 * Hook for adding a connection to a running sandbox.
 *
 * @module hooks/useAddConnection
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sandboxService } from '@/services';
import { sandboxKeys } from './useSandboxes';

/**
 * Hook for adding a connection to a running sandbox.
 * Invalidates the sandbox query on success to trigger a refetch.
 */
export function useAddConnection() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      sandboxId,
      connectionId,
      sandboxGroupId,
    }: {
      sandboxId: string;
      connectionId: string;
      sandboxGroupId?: string;
    }) => sandboxService.addConnection(sandboxId, connectionId, sandboxGroupId),
    onSuccess: (_, variables) => {
      // Invalidate the sandbox query to refetch and show the new connection
      queryClient.invalidateQueries({ queryKey: sandboxKeys.detail(variables.sandboxId) });
    },
  });
}
